import React, { useEffect, useState } from "react";
import "../PurchaseDetails/PurchaseDetails.scss";
import { Button } from "@mui/material";
import { useAppDispatch } from "../../Store/store";
import { currentPlan } from "../../Services/admin.service";

const PurchaseDetails = () => {
  const dispatch = useAppDispatch();
  const [plans, setPlans] = useState<any>();
  
 useEffect(() => {
    const uid = localStorage.getItem('id') || '';
    dispatch(currentPlan({ uid, requiredAdmin: false }))
      .then((response:any) => {
        setPlans(response.payload?.data);
      })
      .catch((error:any) => {
        console.error("Error fetching plans:", error);
      });
  }, [dispatch]);

  function formatDate(isoString: string, planDurationType?: string): string {
    const date = new Date(isoString);
    if (!!planDurationType) {
      if (planDurationType === "yearly") {
        date.setFullYear(date.getFullYear() + 1);
      }
      else if (planDurationType === "monthly") {
        date.setMonth(date.getMonth() + 1);
      }
    }
    const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };
    return date.toLocaleDateString('en-US', options);
  }

  return (
    <>
      <div className="course-list-wrapper">
        <div className="course-list-head-content">
          <h4>Purchase Details</h4>
          <p>View your plan details here.</p>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="purchase-details-card common-card-wrap ">
              <div className="purchase-details-card-head">
                <div className="details-card-title-head">Your Current Plan</div>
                <Button className="active-btn">Active</Button>
              </div>
              <div className="plan-name">YULI Premium {plans?.start_plan?.duration_type}</div>
              <div className="purchase-details-text">
                Start Date:{" "}{plans?.start_plan?.purchase_date ? formatDate(plans?.start_plan?.purchase_date): "-"}
              </div>
              <div className="purchase-details-text">
                Renewal Date:{" "}{plans?.renew_plan?.purchase_date ? formatDate(plans?.renew_plan?.purchase_date, plans?.start_plan?.duration_type): "-"}
              </div>
              <div className="purchase-details-text">Price Paid: ${plans?.start_plan?.amount}0.00</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PurchaseDetails;
